module.exports = __webpack_public_path__ + "img/imperial-diamond.c3d2976b.png";